module.exports = "<style></style> <h1>${this.podaci.naslov}</h1> <div> <img class=full src=${this.podaci.slika} alt=slika> </div> <p>${this.podaci.opis}</p> <div> <button value=${this.podaci.link} class=\"js-start dugme-uranja ${this.css.dugme}\">${this.podaci.akcija}</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/ishod/sablon.html
// module id = 33
// module chunks = 0